import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { formatNumber } from '../../utils/generalFunctions';

/* 'YYYY-MM-DD' se parsea manualmente (en vez de new Date(iso)) para evitar que el
   navegador lo interprete como medianoche UTC y la fecha se recorra un día hacia
   atrás en zonas horarias detrás de UTC (no hay infraestructura de timezone en el
   proyecto, así que esto evita el bug más común al mostrar estas fechas). */
const parseFechaLocal = (iso) => {
    if (!iso) return null;
    const [y, m, d] = String(iso).split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
};

const diaCorto = (fecha) => {
    const d = parseFechaLocal(fecha);
    if (!d) return fecha;
    return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' }).replace('.', '');
};

const diaLargo = (fecha) => {
    const d = parseFechaLocal(fecha);
    if (!d) return fecha;
    return d.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' });
};

const montoCorto = (valor) => {
    const v = Number(valor || 0);
    return v >= 1000 ? `$${Math.round(v / 1000)}k` : `$${Math.round(v)}`;
};

const TooltipPersonalizado = ({ active, payload }) => {
    if (!active || !payload?.length) return null;

    const d = payload[0].payload;

    return (
        <div style={{ background: '#212529', color: '#fff', borderRadius: 6, padding: '8px 12px', fontSize: 13 }}>
            <div>{diaLargo(d.fecha)}</div>
            <strong style={{ display: 'block', fontSize: 15 }}>{formatNumber(d.total, 2, '$', ' MXN')}</strong>
        </div>
    );
};

const GraficaVentas30Dias = ({ data, loading, error }) => {
    if (loading) {
        return (
            <div>
                <div className="esqueleto" style={{ width: '40%' }} />
                <div className="esqueleto" style={{ width: '100%', height: 260 }} />
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-danger text-center py-5" style={{ fontSize: 14 }}>
                <i className="fas fa-triangle-exclamation me-1" />
                No se pudo cargar la gráfica de ventas
            </div>
        );
    }

    const datos = Array.isArray(data) ? data : [];
    const sinVentas = datos.length === 0 || datos.every((d) => Number(d?.total || 0) === 0);

    if (sinVentas) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-muted text-center" style={{ height: 300, fontSize: 14, gap: 6 }}>
                <svg viewBox="0 0 120 40" aria-hidden="true" style={{ width: 120, height: 40 }}>
                    <polyline points="0,34 120,34" fill="none" stroke="#ced4da" strokeWidth="2" strokeDasharray="5 5" />
                </svg>
                Sin ventas en los últimos 30 días
            </div>
        );
    }

    return (
        <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={datos} margin={{ top: 16, right: 12, bottom: 0, left: 0 }}>
                <defs>
                    <linearGradient id="rellenoVentas30Dias" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#1687b5" stopOpacity={0.18} />
                        <stop offset="100%" stopColor="#1687b5" stopOpacity={0} />
                    </linearGradient>
                </defs>
                <CartesianGrid vertical={false} stroke="#e9ecef" />
                <XAxis
                    dataKey="fecha"
                    tickFormatter={diaCorto}
                    tick={{ fontSize: 12, fill: '#6c757d' }}
                    axisLine={{ stroke: '#e9ecef' }}
                    tickLine={false}
                    interval={3}
                />
                <YAxis
                    tickFormatter={montoCorto}
                    tick={{ fontSize: 12, fill: '#6c757d' }}
                    axisLine={false}
                    tickLine={false}
                    width={48}
                />
                <Tooltip content={<TooltipPersonalizado />} />
                <Area
                    type="monotone"
                    dataKey="total"
                    stroke="#1687b5"
                    strokeWidth={2.5}
                    fill="url(#rellenoVentas30Dias)"
                />
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default GraficaVentas30Dias;
